import React from 'react';
import { Link } from 'MWComponents';
import '../less/index.less';

export default function template() {
    const { page, widget, style } = this.props;

    return (
      widget && widget.data && widget.data.length ?
        <div className="downloads">
        <div className={`documents-component ${page}`} style={style}>
          <div className={`content ${page}`}>
            <div className="documents-component-title">
              {widget.data[0].title_ua}
            </div>
            {widget.data.map((file, index) => {
                const filePath = this.changeFilesUrl(file.file_path_ua);
                const fileLink = file.link_path_ua;
                const text = file.name_ua;
                return (<div key={index} className="documents-component-item">
                  <Link href={fileLink ? fileLink : filePath} target="_blank">
                    <img src={this.changeFilesUrl(file.image_path)} alt='doc-img'></img>
                    <div dangerouslySetInnerHTML={{__html: text}}></div>
                  </Link>
                </div>)
              }
            )}
          </div>
        </div>
      </div>
        : ''

    );
}
